import './LoginSection.scss';

import { Outlet } from 'react-router';

const LoginSection = () => {
  return (
    <div className="LoginSection AcronexBackground">
      <Outlet />
    </div>
  );
};

export default LoginSection;
